module.exports = "/images/vendor/flag-icon-css/flags/1x1/gf.svg?cabf9781aaaa1dffbf03f38fcaaacfd3";